module.exports = __webpack_public_path__ + "img/sintesis.df6985c8.svg";